/**
 * @desc 查询参与方看到的出价列表
 */
import { BidRecordEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryParticipantBidRecordListParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/member/bidRecord/list/participant'

export const queryParticipantBidRecordListApi = (
  params?: QueryParticipantBidRecordListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<BidRecordEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryParticipantBidRecordListApi.method = method
queryParticipantBidRecordListApi.url = url
